import React from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "../common/breadcrumb";
import { Helmet } from "react-helmet";
import PaymentMethod from "../../components/pages/Dashboard/components/PaymentMethod";

const PaymentIntegration = () => {
  return (
    <div>
      <Helmet>
        <title>eksplode! | Payment Integration</title>
      </Helmet>
      <Breadcrumb title={"Payment Integration"} />
      {/* Payment integration section */}
      <section className="about-page section-b-space">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <PaymentMethod redirect={true}/>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial */}
    </div>
  );
};

export default PaymentIntegration;
